import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from './../shared/comum.module';
import { translateLoaderNBS } from './../shared/translate-loader/translateLoader';
import { HomeService } from './home-service/home.service';
import { HomeComponent } from './home.component';
import { MessagesModule } from 'primeng/messages';

@NgModule({
  imports: [
    ComumModule,
    CommonModule,
    ChartsModule,
    TooltipModule,
    ToastModule,
    TranslateModule.forRoot(translateLoaderNBS),
    MessagesModule
  ],
  exports: [
    HomeComponent
  ],
  declarations: [
    HomeComponent
  ],
  providers: [
    HomeService
  ]
})
export class HomeModule { }
